export default __webpack_public_path__ + "static/media/36.c53f1377.png";